import isNullOrUndefined from './isNullOrUndefined';

const getFeeCategoryOptions = (feeCategorySpendMapping, companyId, fullFeeCategoryList, feeCategoryList) => {
    if (!feeCategorySpendMapping) {
        return feeCategoryList;
    }

    if (isNullOrUndefined(companyId) || isNullOrUndefined(fullFeeCategoryList)) {
        return [];
    }

    const id = typeof companyId === 'object' && companyId !== null ? companyId.id : companyId;

    const filtered = fullFeeCategoryList.filter(item => item.companyid === id);

    // If the list of options is expected to have a default '--select--' option,
    // we can prepend it if it's not already there.
    // feeCategoryList typically has '--select--' at index 0.
    const hasSelect = feeCategoryList && feeCategoryList.length > 0 && 
                      (feeCategoryList[0] === '--select--' || feeCategoryList[0]?.id === '--select--');

    if (hasSelect) {
        return [feeCategoryList[0], ...filtered];
    }

    return filtered;
};

export default getFeeCategoryOptions;
